import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  FluentProvider,
  webLightTheme,
  mergeClasses,
} from '@fluentui/react-components';
import {
  withOverridableStyles,
} from '@bingads-webui-campaign-react/ads-studio-shared-components';
import {
  PromptEditor as SharedPromptEditor, MAX_PROMPT_LENGTH,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { getPromptEditorStyles } from '../../styles/prompt-editor-styles';

const PromptEditorImpl = ({
  disabled,
  promptValue,
  onPromptChanged,
  onGenerateImageBackground,
  classes,
  logger,
  i18n,
}) => {
  const onFreeTextPromptChanged = useCallback((newValue) => {
    onPromptChanged(newValue);
  }, [onPromptChanged]);

  const onClick = useCallback(() => {
    onGenerateImageBackground();
    logger.logTrace('Copilot change image background - generation view - generate button clicked', { prompt: promptValue });
  }, [logger, onGenerateImageBackground, promptValue]);

  const onFreeTextPromptKeyDown = useCallback((event) => {
    if (event && event.key === 'Enter') {
      onGenerateImageBackground();
      logger.logTrace('Copilot change image background - generation view - generate keyboard button clicked', { prompt: promptValue });
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }, [logger, onGenerateImageBackground, promptValue]);

  return (
    <FluentProvider theme={webLightTheme}>
      <div className={mergeClasses(classes.promptEditorRoot, disabled && 'disabled')}>
        <SharedPromptEditor
          i18n={i18n}
          prompt={promptValue}
          setPrompt={onFreeTextPromptChanged}
          disabledText={disabled}
          onClickGenerateButton={onClick}
          onKeyDownInTextArea={onFreeTextPromptKeyDown}
          disabledButton={!promptValue || promptValue.length > MAX_PROMPT_LENGTH || disabled}
          placeholder={i18n.getString(_TL_('Describe the background you want. You can use the examples on the right for inspiration.'))}
        />
      </div>
    </FluentProvider>
  );
};

PromptEditorImpl.propTypes = {
  disabled: PropTypes.bool,
  promptValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      name: PropTypes.string,
      value: PropTypes.string,
      text: PropTypes.string,
    })),
  ]),
  onPromptChanged: PropTypes.func.isRequired,
  onGenerateImageBackground: PropTypes.func.isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    promptEditorRoot: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

PromptEditorImpl.defaultProps = {
  disabled: false,
  promptValue: '',
};

export const PromptEditor = withOverridableStyles(PromptEditorImpl, getPromptEditorStyles);
